var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"giochi"},domProps:{"innerHTML":_vm._s(_vm.getOrganization.data.block4)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }